import React from "react";
import { Music2, Apple, Youtube, Cloud, ArrowUpRight } from "lucide-react";

export const STREAM_PLATFORMS = [
  { key: "spotify", label: "Spotify", Icon: Music2, placeholder: "https://open.spotify.com/…" },
  { key: "apple_music", label: "Apple Music", Icon: Apple, placeholder: "https://music.apple.com/…" },
  { key: "youtube", label: "YouTube", Icon: Youtube, placeholder: "https://youtube.com/watch?v=…" },
  { key: "soundcloud", label: "SoundCloud", Icon: Cloud, placeholder: "https://soundcloud.com/…" },
];

export const StreamLinks = ({ links }) => {
  const active = STREAM_PLATFORMS.filter((p) => links?.[p.key]);
  if (!active.length) return null;
  return (
    <div className="mt-6 max-w-md" data-testid="stream-links">
      <div className="font-mono-label text-[10px] text-neutral-400 mb-2">ALSO STREAMING ON</div>
      <div className="grid grid-cols-2 gap-2">
        {active.map(({ key, label, Icon }) => (
          <a key={key} href={links[key]} target="_blank" rel="noopener noreferrer"
            className="flex items-center justify-between gap-2 px-3 py-2.5 border border-neutral-800 hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors font-mono-label text-[11px] uppercase"
            data-testid={`stream-link-${key}`}>
            <span className="flex items-center gap-2"><Icon size={14} /> {label}</span>
            <ArrowUpRight size={12} />
          </a>
        ))}
      </div>
    </div>
  );
};

export const StreamLinksFields = ({ value, onChange, testPrefix = "form" }) => (
  <div className="border border-neutral-800 p-4" data-testid={`${testPrefix}-stream-links`}>
    <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3">STREAMING LINKS · OPTIONAL</div>
    <div className="grid sm:grid-cols-2 gap-3">
      {STREAM_PLATFORMS.map(({ key, label, placeholder }) => (
        <label key={key} className="block">
          <span className="font-mono-label text-[9px] text-neutral-500 block mb-1">{label.toUpperCase()}</span>
          <input type="url" className="input-brut text-sm" placeholder={placeholder} value={value?.[key] || ""}
            onChange={(e) => onChange({ ...(value || {}), [key]: e.target.value.trim() })}
            data-testid={`${testPrefix}-stream-${key}`} />
        </label>
      ))}
    </div>
  </div>
);
